// import "tailwindcss/dist/base.css";
import "styles/globalStyles.css";
import React from "react";
import { css } from "styled-components/macro"; //eslint-disable-line

import ComponentRenderer from "ComponentRenderer.js";
import Home from "MainPage.js";

import ThankYouPage from "ThankYouPage.js";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import SubjectView from "pages/subjectView";
import ContentView from "pages/contentData";
import "@fortawesome/fontawesome-free/css/all.css";
import SocialSidebar from "components/features/SocialSidebar";

export default function App() {
  // If you want to disable the animation just use the disabled `prop` like below on your page's component
  // return <AnimationRevealPage disabled>xxxxxxxxxx</AnimationRevealPage>;

  return (
    <>
      <SocialSidebar />
      <Router basename={"/vac"}>
        <Switch>
          <Route path="/:type/:subtype/:name">
            <ComponentRenderer />
          </Route>
          {/* <Route path="/subject/:subjectview" element={<SubjectView />} /> */}
          <Route path="/subject">
            <SubjectView />
          </Route>
          <Route path="/content">
            <ContentView />
          </Route>
          <Route path="/:type/:name">
            <ComponentRenderer />
          </Route>
          <Route path="/:name">
            <ComponentRenderer />
          </Route>
          <Route path="/thank-you">
            <ThankYouPage />
          </Route>
          <Route path="/">
            <Home />
          </Route>
        </Switch>
      </Router>
    </>
  );
}
